import { faSearch, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { Form } from 'mk2/components/Form';
import { autoFocusElement, AutoFocus } from 'mk2/helpers/form';
import React from 'react';
import styles from './SearchBox.mscss';

interface OwnProps {
    query: string;
    placeholder: string;
    autoFocus?: AutoFocus;
    noClear?: boolean;

    onChange(searchQuery: string);
    onSubmit?(searchQuery: string);
}

export class SearchBox extends React.Component<OwnProps> {

    private input: HTMLInputElement;

    public render() {
        const { query, placeholder, noClear } = this.props;

        return (
            <div className={styles.SearchBox}>
                <Form className={cx(styles.SearchBox__field)} onSubmit={this.onSubmit}>
                    <FontAwesomeIcon icon={faSearch} className={styles.SearchBox__icon} />

                    <input
                        className={styles.SearchBox__input}
                        type="text"
                        placeholder={placeholder}
                        value={query}
                        onChange={this.onChange}
                        ref={(r) => this.input = r}
                    />

                    {query && !noClear && (
                        <a data-google-interstitial="false" className={styles.SearchBox__clear} onClick={this.onClear}>
                            <FontAwesomeIcon icon={faTimesCircle} className={styles.SearchBox__clear__icon} />
                       </a>
                    )}
                </Form>
            </div>
        );
    }

    public componentDidMount() {
        autoFocusElement(this.input, this.props.autoFocus, this.props.query);
    }

    private onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (this.props.onSubmit) {
            this.props.onSubmit(this.props.query);
        }
    };

    private onChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onChange(e.currentTarget.value);
    };

    private onClear = (e: React.MouseEvent<HTMLAnchorElement>) => {
        this.props.onChange('');
    };

}
